import {isNil} from 'lodash';

export default class Confetti {

	constructor(selector, options = null) {
		this.target = $(selector);
		this.canvas = null;
		this.context = null;
		this.drawInterval = 0;
		this.setRelative = true;
		this.offsetX = 0;
		this.offsetY = 0;
		this.offsetWidth = 0;
		this.offsetHeight = 0;

		this.numParticles = 30;
		this.particles = [];

		this.angle = 0;
		this.tiltAngle = 0;

		if (!isNil(options)) {
			for (var key in options) {
				this[key] = options[key];
			}
		}

		$(window).resize(this.setDimensions.bind(this));

		this.initialize();

		if (this.easterEgg && this.panda) {
			this.panda.onload = this.start.bind(this);
			this.panda.src = 'data:image/png;base64,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';
		} else {
			this.start();
		}
	}

	initialize() {
		this.canvas = document.createElement("canvas");
		if (this.cssClass) {
			this.canvas.classList.add(this.cssClass);
		}
		if (this.setRelative) {
			this.target.css('position', 'relative');
		}
		this.target.prepend(this.canvas);
		$(this.canvas).css('position', 'absolute');
		$(this.canvas).css('top', this.offsetY);
		$(this.canvas).css('left', this.offsetX);
		this.setDimensions();

		this.context = this.canvas.getContext("2d");

		for (var i = 0; i < this.numParticles; i++) {
			this.particles.push(this.getNewParticle());
		}

		if ((window.ENV === 'dev' || window.SESSION_USER.companyId.match(/28448|2218|20/)) && this.easterEgg) {
			this.panda = new Image();

			for (let i = 0; i < this.numParticles / 5; i++) {
				this.particles.push({...this.getNewParticle(), isPanda: true});
			}
		}
	}

	setDimensions() {
		this.canvas.width = this.target.outerWidth() + this.offsetWidth - 1;
		this.canvas.height = this.target.outerHeight() + this.offsetHeight - 1;
	}

	draw() {
		this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
		for (let i = 0; i < this.particles.length; i++) {
			const p = this.particles[i];
			if (p.isPanda) {
				this.context.drawImage(this.panda, p.xPos, p.yPos);
			} else {
				this.context.beginPath();
				this.context.lineWidth = p.size * 0.3;
				this.context.strokeStyle = p.color;
				this.context.moveTo(p.xPos + p.tilt + (p.size * 0.25), p.yPos);
				this.context.lineTo(p.xPos + p.tilt, p.yPos + (p.tilt * 0.5) + (p.size * 0.1));
				this.context.stroke();
			}
		}

		this.update();
	}

	getNewParticle() {
		return {
			xPos: Math.random() * this.canvas.width,
			yPos: Math.random() * this.canvas.height,
			size: this.randomFromTo(5, 30),
			density: (Math.random() * this.numParticles) + 10,
			color: `rgba(${ Math.floor((Math.random() * 255)) }, ${ Math.floor((Math.random() * 255)) }, ${ Math.floor((Math.random() * 255)) }, 0.7)`,
			tilt: Math.floor(Math.random() * 10) - 10,
			tiltAngleIncremental: (Math.random() * 0.04) + 0.03,
			tiltAngle: 0
		};
	}

	randomFromTo(from, to) {
		return Math.floor(Math.random() * (to - from + 1) + from);
	}

	update() {
		this.angle += 0.01;
		this.tiltAngle += 0.1;

		for (let i = 0; i < this.particles.length; i++) {
			const p = this.particles[i];
			p.tiltAngle += p.tiltAngleIncremental;
			p.yPos += (Math.cos(this.angle + p.density) + 1 + p.size * 0.5) * 0.15;
			p.xPos += Math.sin(this.angle) * 0.5;
			p.tilt = (Math.sin(p.tiltAngle - (i / 3))) * 15;

			// Sending particles back from the top when it exits
			if (p.xPos > this.canvas.width + 15 || p.xPos < -15 || p.yPos > this.canvas.height + 15) {
				p.tilt = Math.floor(Math.random() * 10) - 10;
				// 66.67% of the particles
				if (i % 5 > 0 || i % 2 == 0) {
					p.xPos = Math.random() * this.canvas.width;
					p.yPos = -10;
				} else {
					p.yPos = Math.random() * this.canvas.height;
					// eslint-disable-next-line max-depth
					if (Math.sin(this.angle) > 0) {
						// From the left
						p.xPos = -5;
					} else {
						// From the right
						p.xPos = this.canvas.width + 5;
					}
				}
			}
		}
	}

	start() {
		this.drawInterval = setInterval(this.draw.bind(this), 20);
	}

	stop() {
		clearTimeout(this.drawInterval);
		if (!isNil(this.context)) {
			this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
		}
	}

}
